import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_DOCTOR_WALLET } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getLocalizedErrorMessage } from "../../utils/messageHelper";
import i18n from "../../i18n";

// API: GET /consultation/doctor/wallet/transactions with unified transaction support
export const fetchDoctorWalletUnifiedTransactionsReducer = createAsyncThunk(
  ACTION_DOCTOR_WALLET.fetch_doctor_wallet_unified_transactions,
  async (params = {}, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      // Build query parameters for the unified transactions API
      const queryParamsObj = {};

      // Add date filter (YYYY-MM-DD format)
      if (params.date) queryParamsObj.date = params.date;

      // Add search filter
      if (params.search) queryParamsObj.search = params.search;

      // Add payment method filter
      if (params.payment_method)
        queryParamsObj.payment_method = params.payment_method;

      // Add transaction type filter
      if (params.transaction_type)
        queryParamsObj.transaction_type = params.transaction_type;

      // Add COD status filter
      if (params.cod_status) queryParamsObj.cod_status = params.cod_status;

      // Add pagination parameters
      if (params.page) queryParamsObj.page = params.page;
      if (params.limit) queryParamsObj.limit = params.limit;

      const queryParams = new URLSearchParams(queryParamsObj);

      const queryString = queryParams.toString();
      const url = `${process.env.REACT_APP_API_URL}${APP_PATH.getDoctorWalletUnifiedTransactions}${queryString ? `?${queryString}` : ""}`;

      console.log("Fetching unified transactions from:", url);

      const response = await axiosPrivate.get(url);

      if (response?.data?.status === true || response?.status === 200) {
        console.log(
          "Doctor Wallet Unified Transactions Response:",
          response.data.data,
        );

        // Handle new API response structure (flat array)
        const responseData = response.data.data;

        // If response is an array, wrap it in the expected structure
        if (Array.isArray(responseData)) {
          const page = params.page || 1;
          const limit = params.limit || 10;
          const totalRecords = responseData.length;
          const totalPages = Math.ceil(totalRecords / limit);

          return {
            transactions: responseData,
            pagination: {
              page: page,
              limit: limit,
              total: totalRecords,
              total_pages: totalPages,
              has_next_page: page < totalPages,
              has_previous_page: page > 1,
            },
            summary: {
              total_earnings: responseData.reduce(
                (sum, t) => sum + parseFloat(t.amount || 0),
                0,
              ),
              currency: "IQD",
              transaction_count: totalRecords,
              category_breakdown: {
                cash: 0,
                wallet: 0,
                card: 0,
              },
            },
          };
        }

        // If response already has the expected structure, return as is
        return responseData;
      } else {
        const message = getLocalizedErrorMessage({ response }, i18n);
        toast.error(message);
        return rejectWithValue(message);
      }
    } catch (error) {
      console.error(
        "Error fetching doctor wallet unified transactions:",
        error,
      );
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message);
      return rejectWithValue(message);
    }
  },
);
